import { Check, Minus } from 'lucide-react';
import Reveal from './Reveal';

type Cell = string | boolean;
const rows: { label: string; sheet: Cell; chat: Cell; cfx: Cell }[] = [
  { label: 'Every listing complete', sheet: 'Scattered across files', chat: 'Scattered across messages', cfx: 'COA, photo, price in one listing' },
  { label: 'Stays current', sheet: 'Goes stale the day you send it', chat: 'Buried by the next message', cfx: 'Updates in place' },
  { label: 'Goes only to buyers you choose', sheet: 'Forwarded anywhere', chat: 'Seen by the whole group', cfx: 'Shared by named link' },
  { label: 'Can be switched off', sheet: false, chat: false, cfx: true },
  { label: 'Shows who looked', sheet: false, chat: false, cfx: true },
];

const render = (c: Cell, strong = false) =>
  typeof c === 'boolean' ? (
    c ? (
      <Check className="h-4 w-4 text-brand" aria-label="Yes" />
    ) : (
      <Minus className="h-4 w-4 text-muted-foreground" aria-label="No" />
    )
  ) : (
    <span className={strong ? 'font-medium text-foreground' : 'text-muted-foreground'}>{c}</span>
  );

/** The real competitor is today's workflow — never a named platform. */
const ComparisonTable = () => (
  <section className="border-b border-border bg-background py-20 md:py-24">
    <div className="container-wide">
      <Reveal className="max-w-2xl">
        <h2 className="text-3xl font-semibold tracking-tight sm:text-4xl">
          Why not just a spreadsheet?
        </h2>
      </Reveal>

      <Reveal delay={100} className="mt-10">
        <div className="overflow-hidden rounded-xl border border-border">
          <table className="w-full text-left text-sm">
            <thead className="bg-subtle">
              <tr>
                <th scope="col" className="sr-only md:not-sr-only md:p-4 md:font-medium">What you need</th>
                <th scope="col" className="hidden p-4 font-medium sm:table-cell">Spreadsheet or PDF</th>
                <th scope="col" className="hidden p-4 font-medium sm:table-cell">Group chat broadcast</th>
                <th scope="col" className="p-4 font-semibold text-brand-text">Cannafax</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {rows.map((r) => (
                <tr key={r.label} className="align-top">
                  <th scope="row" className="p-4 font-medium">
                    {r.label}
                    <span className="mt-1 block text-xs font-normal text-muted-foreground sm:hidden">
                      Spreadsheet: {typeof r.sheet === 'boolean' ? (r.sheet ? 'Yes' : 'No') : r.sheet} · Chat:{' '}
                      {typeof r.chat === 'boolean' ? (r.chat ? 'Yes' : 'No') : r.chat}
                    </span>
                  </th>
                  <td className="hidden p-4 sm:table-cell">{render(r.sheet)}</td>
                  <td className="hidden p-4 sm:table-cell">{render(r.chat)}</td>
                  <td className="p-4">{render(r.cfx, true)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-5 max-w-2xl text-sm text-muted-foreground">
          Keep your spreadsheet and import it. Keep the ordering tools you use today. Cannafax adds
          what they can’t.
        </p>
      </Reveal>
    </div>
  </section>
);

export default ComparisonTable;
